export default __webpack_public_path__ + "static/media/footer-bg.f9bdf3e5.png";